export default {
  Admin: 'Admin',
  Insight: 'InsightUser',
  Flights: 'FlightsUser',
  Pax: 'PaxUser',
  Bays: 'BaysUser',
  PaxTotals: 'PaxTotalsUser',
  FlightStats: 'FlightStatsUser',
  AgentTotals: 'AgentTotalsUser',
  Kiosk: 'KioskUser',
}
